import Api from "@/components/services/Api"
import PermissionHandler from "@/components/services/Permissions"

export default {
  data() {
    return {
      plan: null,
      permissions: {
        insignias: false,
        cualificacion: false,
        educacion: false,
        especialidades: false,
        foto_perfil: false,
        numero_licencia: false,
        primeros_auxilios_rcp: false,
        puntuacion_profesional: false,
        redes_sociales: false,
        seguro_rc: false,
        sobre_mi: false,
        soporte_vital: false,
        url_personalizada: false,
        verificacion_titulaciones: false,
      }
    }
  },
  async created() {
    if (this.token) {
      if (!this.user) return
      const meResponse = await Api.me(this.token)

      this.plan = this.user.plan

      const permissionResponse = await Api.getPermissions()
      const data = permissionResponse.data
      const handler = new PermissionHandler(data, this.plan)

      // detect permissions
      this.permissions.insignias = handler.hasPermission("PERFIL_INSIGNIAS")
      this.permissions.cualificacion = handler.hasPermission("PERFIL_CUALIFICACION")
      this.permissions.educacion = handler.hasPermission("PERFIL_EDUCACION")
      this.permissions.especialidades = handler.hasPermission("PERFIL_ESPECIALIDADES")
      this.permissions.foto_perfil = handler.hasPermission("PERFIL_FOTO_PERFIL")
      this.permissions.numero_licencia = handler.hasPermission("PERFIL_NUMERO_LICENCIA")
      this.permissions.primeros_auxilios_rcp = handler.hasPermission("PERFIL_PRIMEROS_AUXILIOS_RCP")
      this.permissions.redes_sociales = handler.hasPermission("PERFIL_REDES_SOCIALES")
      this.permissions.seguro_rc = handler.hasPermission("PERFIL_SEGURO_RC")
      this.permissions.sobre_mi = handler.hasPermission("PERFIL_SOBRE_MI")
      this.permissions.soporte_vital = handler.hasPermission("PERFIL_SOPORTE_VITAL")
      this.permissions.url_personalizada = handler.hasPermission("PERFIL_URL_PERSONALIZADA")
      this.permissions.verificacion_titulaciones = handler.hasPermission("PERFIL_VERIFICACION_TITULACIONES")
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Permissions.js